import { NgModule } from '@angular/core';
import { TemplateFormComponent } from './template-form-component';


@NgModule({
    declarations: [TemplateFormComponent],
    exports: [TemplateFormComponent]
})
export class TemplateFormModule { }


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/form-controls/template-form-module/template-form-module.ts